export default {
    watch: {
        active(val) {
            if ( val ) {
                this.$refs.el.focus();
            }
        }
    },
    methods: {
        blur(el) {
            this.active = this.$parent.fields[el] ? true : false;
        }
    },
    created() {
        bus.$on('prefill:trigger', () => {
            this.$refs.el.focus();
        });
    }
}